import { useState, useRef, useEffect } from 'react';
import '../index.css';

import SchemaBuilder from './SchemaBuilder';
import Intro from './Intro';

import { getOrigin } from '../utils';
import demoJson from '../assets/blaze-menu-demo.json';

const PAGES = {
  INTRO: 'INTRO',
  SCHEMA_BUILDER: 'SCHEMA_BUILDER',
};

const postMessageToIframe = (actionType: any, payload: any) => {
  const origin = getOrigin();
  const iframeElement = document.querySelector(`iframe[src^="${origin}"]`);

  // @ts-ignore:next-line
  if (!!iframeElement && !!iframeElement.contentWindow?.postMessage) {
    try {
      // @ts-ignore:next-line
      iframeElement.contentWindow.postMessage(
        {
          sender: 'blazeit',
          actionType,
          payload,
        },
        '*'
      );
    } catch (error) {
      console.log('Error occurred while communicated with the frontend', error);
    }
  }
};

export default function Main() {
  const [currentPage, setCurrentPage] = useState(PAGES.INTRO);
  const [livePreviewOn, setLivePreviewOn] = useState(false);

  const schemaRef = useRef();

  const eventListener = async (event: any) => {
    try {
      if (event.data.sender !== 'blazeit') {
        return;
      }

      const { actionType } = event.data;

      switch (actionType) {
        case 'cargando':
          const menuJson =
            currentPage === PAGES.INTRO
              ? demoJson
              : // @ts-ignore:next-line
                schemaRef.current.blazeMenuJson;

          postMessageToIframe('s', {
            menuJson,
            previewOn: !window.location.search.includes('free=karlo'),
          });

          break;

        case 'q':
          // @ts-ignore:next-line
          setLivePreviewOn(false);
          break;
      }
    } catch (error) {
      console.log('[orchestra] event listener error', error);
    }
  };

  useEffect(() => {
    window.addEventListener('message', eventListener);

    return () => {
      window.removeEventListener('message', eventListener);
    };
  }, [currentPage]);

  useEffect(() => {
    const body = document.getElementsByTagName('body')[0];

    if (livePreviewOn) {
      body.classList.add('freeze');
    } else {
      body.classList.remove('freeze');
    }
  }, [livePreviewOn]);

  useEffect(() => {
    if (window.location.search.includes('mode=create')) {
      setCurrentPage(PAGES.SCHEMA_BUILDER);
    }

    if (window.location.search.includes('free=karlo')) {
      setLivePreviewOn(true);
    }
  }, []);

  if (currentPage === PAGES.INTRO) {
    return (
      <Intro
        onSchemaBuilder={() => setCurrentPage(PAGES.SCHEMA_BUILDER)}
        livePreviewOn={livePreviewOn}
        setLivePreviewOn={setLivePreviewOn}
      />
    );
  }

  if (currentPage === PAGES.SCHEMA_BUILDER) {
    return (
      <SchemaBuilder
        goBack={() => setCurrentPage(PAGES.INTRO)}
        // @ts-ignore:next-line
        ref={schemaRef}
        livePreviewOn={livePreviewOn}
        setLivePreviewOn={setLivePreviewOn}
      />
    );
  }

  return null;
}
